import { PROVIDER_ESCAPIO } from "../api/provider-codes";

/**
 * @returns true, if there is an active escapio rate (can be unavailable) for this hotel, false otherwise
 */
export function hasEscapioRate(hotel) {
	return Boolean(
		hotel.active_rates && Object.keys(hotel.active_rates).length > 0,
	);
}

const hasProviderAndPrice = offer =>
	offer?.provider === PROVIDER_ESCAPIO && offer?.total_rate;

/**
 * @returns true, if there is an active AND available escapio rate for this hotel, false otherwise
 */
export function hasEscapioOffer(offers) {
	return Boolean(offers?.[0] && hasProviderAndPrice(offers[0]));
}

export function getEscapioDiscount(hotel, offer) {
	return hasEscapioRate(hotel) && offer?.rate?.id
		? hotel.active_rates[offer?.rate.id]?.discount || null
		: null;
}
